import { Box, Button, ButtonGroup, IconButton } from "@mui/material";
import { toolPanelStyles } from "../utils/gridHelper";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import OutlinedInput from "@mui/material/OutlinedInput";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";

export default function GridToolBar({
  onUpdate,
  onDelete,
  onAdd,
  onRefresh,
  filter,
  filterValue,
  filterOnChange,
  dataToAction,
}) {
  return (
    <Box
      sx={{
        ...toolPanelStyles,
        height: "50px",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <ButtonGroup variant="contained" sx={{ height: "30px" }}>
        <Button
          color={"success"}
          disabled={!onAdd}
          onClick={onAdd}
          startIcon={<AddIcon />}>
          Добавить
        </Button>
        <Button
          color={"warning"}
          disabled={!dataToAction || !onUpdate}
          onClick={onUpdate}
          startIcon={<EditIcon />}>
          Изменить
        </Button>
        <Button
          color={"error"}
          disabled={!dataToAction || !onDelete}
          onClick={onDelete}
          startIcon={<DeleteIcon />}>
          Удалить
        </Button>
        <Button
          startIcon={<RefreshIcon />}
          disabled={!onRefresh}
          onClick={onRefresh}>
          Обновить
        </Button>
      </ButtonGroup>

      {filter && (
        <Grid size={{ xs: 12, md: 6 }}>
          <OutlinedInput
            id={"quickFilter"}
            name={"quickFilter"}
            size="small"
            onChange={(e) => filterOnChange(e.target.value)}
            value={filterValue}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  sx={{ p: "2px" }}
                  onClick={() => filterOnChange("")}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
      )}
    </Box>
  );
}
